import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import { useId } from 'react-id-generator';
import PostcodeAutocomplete from '$components/basic/PostcodeAutocomplete';
import styles from './PostcodeInput.module.scss';

/**
 * @NOTE
 * This is a cloned component for temporary restyling purposes only!
 * It is intended for use ONLY for dynamic route pages which are CMS driven.
 *
 * The PostcodeInput is to be completely rewritten as a Quantum Component
 * after which this file will be deleted from the project.
 */

export interface PostcodeInputProps {
  placeholder: string;
  useAutocomplete: boolean;
  spellCheck?: boolean;
  floating?: boolean;
  label?: string;
  onChange?: (e: string) => void;
  inputType?: string;
  className?: string;
}

export default function PostcodeInput({
  placeholder,
  useAutocomplete = true,
  spellCheck,
  floating,
  label,
  onChange,
  className = '',
  ...props
}: PostcodeInputProps): JSX.Element {
  const [{ value }, { error, initialValue, touched }, { setValue, setTouched }] = useField('postcode');
  const isValid = value && !error && touched;

  const [uniqId] = useId(); // generated unique id (CSR&SSR)

  const onPostcodeChange = useCallback(
    (postcode: string) => {
      setValue(postcode);
      setTouched(true);
    },
    [setValue, setTouched]
  );

  return (
    <PostcodeAutocomplete
      useAutocomplete={useAutocomplete}
      uniqId={uniqId}
      className={classNames(className, styles.PostcodeInput, isValid && `-valid`)}
      onChange={(e: string) => {
        onPostcodeChange(e);
        if (onChange) onChange(e);
      }}
      placeholder={placeholder}
      headerPlaceholder={placeholder}
      floating={floating}
      label={label}
      initialValue={initialValue}
      spellCheck={spellCheck}
      {...props}
    />
  );
}
